/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import OrganizationForm from 'components/organization/OrganizationForm';
import { isEmpty } from 'lodash';
import OrganizationFormFooter from 'components/organization/OrganizationFormFooter';
import { Breadcrumbs, Typography } from '@material-ui/core';
import { useLinkStyles } from 'components/common/useLinkStyles';
import { IsInRole } from 'shared/authorization/IsInRole';
import { Roles } from 'shared/enums/Roles';
import { RoutePath } from 'shared/enums/RoutePath';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Backdrop from 'components/backdrop/Backdrop';
import DeleteOrganization from './components/DeleteOrganization';
import useOrganizationEditor from '../../redux/features/organization/organizationEditor/useOrganizationEditor';

function OrganizationEditor() {
  document.title = 'Organization Editor';
  const linkClass = useLinkStyles();
  const { t } = useTranslation();
  const { organisationId } = useParams();

  const {
    uiSchema,
    validationSchema,
    onUpdateOrganization,
    onSubmit,
    organization,
    isValid,
    isLoading,
    checkIfFormIsValid,
  } = useOrganizationEditor(organisationId);

  const showForm = !isEmpty(validationSchema) && !isEmpty(uiSchema) && !isLoading;
  return (
    <>
      <div className="wideContainer">
        <Breadcrumbs aria-label="breadcrumb" className="breadcrumbs">
          <Link className={linkClass.link} to={RoutePath.DASHBOARD.path}>
            {t('front.office.dashboard')}
          </Link>
          <Typography color="textPrimary">{t('user-management.my.profile')}</Typography>
        </Breadcrumbs>

        {!showForm && <Backdrop blocking={true} />}
        {showForm && (
          <OrganizationForm
            uiSchema={uiSchema}
            editMode={!!organisationId}
            jsonSchema={validationSchema}
            onSubmit={onSubmit}
            organization={organization}
            updateOrganization={onUpdateOrganization}
            checkIfFormIsValid={checkIfFormIsValid}
          />
        )}
        {showForm && organisationId && (
          <IsInRole roles={[Roles.END_USER_ADMIN]}>
            <DeleteOrganization />
          </IsInRole>
        )}
      </div>
      <OrganizationFormFooter editMode={!!organisationId} onSave={onSubmit} disabled={!isValid} />
    </>
  );
}

export default OrganizationEditor;
